module.exports = __webpack_public_path__ + "public/images/info-progress.a877d248dfa7c5153f493e21af2e31f7.svg";